import { Typography } from '@mui/material';
import { memo } from 'react';

import { TextField } from '@/components';

import { InputKey } from '../types';
import { TableCell, TableRow } from './Table';

interface InviteMembersFormRowProps {
  id: string;
  email: string;
  editableEmails: boolean;
  emailError: boolean;
  name: string;
  nameError: boolean;
  onChange: (id: string, key: InputKey, value: string) => void;

  rowNumber?: number;
}

export const InviteMembersFormRow = memo(function InviteMembersFormRow({
  id,
  rowNumber,
  email,
  emailError,
  name,
  nameError,
  onChange,
  editableEmails,
}: InviteMembersFormRowProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(id, e.target.id as InputKey, e.target.value);
  };

  return (
    <TableRow sx={styles.inputRow}>
      {rowNumber && (
        <TableCell sx={styles.rowCell}>
          <Typography variant="body2">{rowNumber}</Typography>
        </TableCell>
      )}
      <TableCell sx={[styles.inputCell, styles.emailCell]}>
        {editableEmails ? (
          <TextField
            aria-label="Email"
            type="email"
            id="email"
            required
            placeholder="Email"
            value={email}
            onChange={handleChange}
            error={emailError}
            fullWidth
          />
        ) : (
          <Typography variant="body2">{email}</Typography>
        )}
      </TableCell>
      <TableCell sx={styles.inputCell}>
        <TextField
          aria-label="Name"
          id="name"
          required
          placeholder="Name"
          value={name}
          error={nameError}
          onChange={handleChange}
          fullWidth
        />
      </TableCell>
    </TableRow>
  );
});

const styles = {
  rowCell: {
    width: 60,
  },
  inputCell: { pr: 1.5 },
  emailCell: {
    width: '40%',
  },
  removeCell: {
    width: 36,
    pr: 0,
  },
  inputRow: {
    '.MuiIconButton-root': {
      opacity: 0,
    },
    '&:hover': {
      '.MuiIconButton-root': {
        opacity: 1,
      },
      '.MuiIconButton-root[disabled]': {
        opacity: 0,
      },
    },
  },
};
